import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
    class: "input-group",
    ref: "inputGroupElement"
};
const _hoisted_2 = ["required"];
const _hoisted_3 = /*#__PURE__*/ _createElementVNode("div", { class: "input-group-addon" }, [
    /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-calendar" })
], -1);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("input", {
            type: "text",
            class: "form-control",
            required: _ctx.required
        }, null, 8, _hoisted_2),
        _hoisted_3
    ], 512));
}
